import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridReusableMoleculeComponent } from '../../molecules/grid-reusable-molecule/grid-reusable-molecule.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClickStreamAnalyticsService, EventType } from 'src/app/services/clickstream-analytics-service';
import { FilterBayService } from 'src/app/services/filter-bay.service';
import { SyncfusionService } from 'src/app/services/syncfusion.service';
import { ReusableFilterMoleculeComponent } from '../../molecules/reusable-filter-molecule/reusable-filter-molecule.component';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { DataResult, DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-store-plans-tab-organism',
  templateUrl: './store-plans-tab-organism.component.html',
  styleUrls: ['./store-plans-tab-organism.component.scss']
})
export class StorePlansTabOrganismComponent implements OnInit, OnDestroy {
  @ViewChild('gridRef') gridRef!: GridReusableMoleculeComponent;
  @ViewChild("childFilter", { static: false }) public childComponent !: ReusableFilterMoleculeComponent;
  showFilter: boolean = false;
  filterData: any;
  showFiltersPopup: boolean = false;
  generatedDate: any
  reportLabelText: string;
  selectedTabIndex: number = 0;
  tableDataFetched: boolean;
  reportName: any;
  data: any;
  dynamic_headers: [];
  count: any;
  appliedFilters: any = {};
  showCreateReplenishmentBtn: boolean = false;
  showPrintReplenishmentBtn: boolean = false;
  tabList = [
    { label: 'Store Replenishment Plan', report: 'In_Store_Replenishment_Plan' },
    { label: 'Replacement Styles Count by Category', report: 'store_replacement_allocation' }
  ];

  constructor(private syncfusion: SyncfusionService, private snack: MatSnackBar, private clickStream: ClickStreamAnalyticsService,
    private filterbayservice: FilterBayService, private settingsService: AppSettingService,) { }

  ngOnInit(): void {
    this.selectedTabIndex = 0;
    const defaultReport = this.tabList[this.selectedTabIndex].report;
    this.reportName = defaultReport;
    this.loadReportData(defaultReport);
  }
  tabChanged(index: any) {
    this.selectedTabIndex = index;
    const selectedReport = this.tabList[index].report;
    this.reportName = selectedReport;
    this.tableDataFetched = false;
    this.loadReportData(selectedReport);
  }
  loadReportData(reportName: string) {
    this.tableDataFetched = false;
    if (this.settingsService.isRemoteGridMode()) {
      this.syncfusion.getPaginatedSyncfusionData(this.reportName).subscribe((res) => {

        if (res) {
          this.getFilters(reportName);
          this.data = (<DataResult>{
            result: res.items,
            count: res.pageData ? res.pageData.totalRecords : res.count
          });
          this.showCreateReplenishmentBtn = true;
          this.showPrintReplenishmentBtn = true;
          this.appliedFilters = this.filterbayservice.getReportFilters(this.reportName)["displayFilters"];
          this.generatedDate = this.data?.result[0]?.recordDate;
          this.dynamic_headers = JSON.parse(res.headerContent);
          this.syncfusion.setExportData(res);
          this.reportLabelText = res.baseReportText;
          this.count = res.count;
          setTimeout(() => {
            this.tableDataFetched = true;
          });
        }
      }, (error) => {
        this.tableDataFetched = true;
        console.error(error);
      })
    } else {
      this.syncfusion.getSyncfusionData(this.reportName).then((res) => {
        if (res) {
          this.data = res.items;
          this.generatedDate = this.data[0]?.recordDate;
          this.dynamic_headers = JSON.parse(res.headerContent);
          this.count = res.count;
          this.showCreateReplenishmentBtn = true;
          this.showPrintReplenishmentBtn = true;
          setTimeout(() => {
            this.tableDataFetched = true;
          });
        }
      }, (error) => {
        this.tableDataFetched = true;
        console.error(error);
      });
    }
  }
  selectedFilters(event) {
    this.appliedFilters = JSON.parse(JSON.stringify(event));
  }

  handleHeaderPrintClick() {
    if (this.gridRef) {
      this.gridRef.triggerExcelExportFromOutside();
    }
  }
  showSnackbar(message: string) {
    this.snack.open(message, 'close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  getFilters(reportName: any) {
    this.syncfusion.getAvailableFilters(reportName).subscribe((res: any) => {
      this.filterData = res?.filterDataList;
      this.filterData = this.filterData.sort((a, b) => a.position - b.position);
      this.showFilter = this.filterData.length > 0;
      this.clickStream.publishGAEvent(EventType.FILTER, {
        section: reportName
      });
    }, (error) => {
      this.showSnackbar('Error while fetching filters.Please try again later');
    })
  }
  toggleFilterOverlay() {
    this.showFiltersPopup = !this.showFiltersPopup;
    if (this.showFiltersPopup) {
      this.childComponent.createOverlay();
    }
  }
  ngOnDestroy(): void {
    this.filterbayservice.setReportFilters(this.reportName, {}, {});
    this.appliedFilters = {};
  }
   handleFilterOutput(data: any) {
    const payload = { "gridFilters": data, "pageSize": 200, "pageNumber": 1 }
    // this.reportNameWithSpace = "Just a moment, we're compiling your insights...";
    this.tableDataFetched = false;
    if (this.settingsService.isRemoteGridMode()) {
      this.syncfusion.getPaginatedSyncfusionData(this.reportName, payload).subscribe((res) => {
        if (res) {
          // if (res.displayName && res.displayName.trim() !== '') {
          //   this.reportNameWithSpace = res.displayName;
          // }
          // else {
          //   this.reportNameWithSpace = this.reportName.replace(/_/g, " ");
          // }
          this.data = (<DataResult>{
            result: res.items,
            count: res.pageData ? res.pageData.totalRecords : res.count
          });
          this.reportLabelText = res.baseReportText;
          this.generatedDate = this.data?.result[0]?.recordDate;
          this.dynamic_headers = JSON.parse(res.headerContent);
          this.syncfusion.setExportData(res);
          this.count = res.count;
          setTimeout(() => {
            this.tableDataFetched = true;
          });
        }
      }, (error) => {
        this.tableDataFetched = true;
        console.error(error);
      })
    }
  }
}
